import { useNavigate, useParams } from 'react-router-dom'
import { useAuth, useCategories, useCategory } from '../../hooks'
import { PageFactory } from './PageFactory'
import { LoginPage } from '../'

const CategoryPage = () => {
  const { tenantUrlSlug } = useParams()
  const navigate = useNavigate()
  const { logIn, loggedIn } = useAuth()
  const { categories } = useCategories()
  const { category } = useCategory()

  const onLogin = () => {
    logIn()
    navigate(`/${tenantUrlSlug}`)
  }

  // if not loggedIn, display LoginPage as first category
  const displayCategoryPage = () =>
    loggedIn || category.id !== categories[0].id ? (
      <PageFactory category={category} />
    ) : (
      <LoginPage category={category} onLogin={onLogin} />
    )

  return category ? displayCategoryPage() : null
}

export { CategoryPage }
